import styled from 'styled-components';
import { Card } from '../Card';
import { ModalWindowTypes } from './ModalWindow';
import { JustifyContent } from '../../theming/types/JustifyContent';
import { TextAlign } from '../../theming/types/TextAlign';

//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const ModalWindowContainer = styled.div`
  display: flex;
  position: fixed;
  z-index: 200; //generally above everything. including mini navigation component
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
`;

//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const ModalWindowSubstrate = styled.div`
  background-color: rgba(107, 114, 128, 0.75);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
`;

interface ISizingDivProps {
  height?: string | number;
  minHeight?: string | number;
  width?: string | number;
}
//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const SizingDiv = styled.div<ISizingDivProps>`
  display: grid;
  height: ${({ height }) =>
    typeof height === 'string' ? height : typeof height === 'number' ? height + 'px' : 'auto'};
  min-height: ${({ minHeight }) =>
    typeof minHeight === 'string' ? minHeight : typeof minHeight === 'number' ? minHeight + 'px' : 'auto'};
  width: ${({ width }) => (typeof width === 'string' ? width : typeof width === 'number' ? width + 'px' : 'auto')};
`;

//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const StyledCard = styled(Card)`
  padding: 16px;
  max-height: 90vh;
  overflow-y: auto;
`;

//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const sizeMap: { [K in ModalWindowTypes]: { height: string | undefined; width: string | undefined } } = {
  fit: { height: undefined, width: undefined },
  medium: { height: '350px', width: '530px' },
  small: { height: '250px', width: '400px' },
};

//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const ModalWindowCard = styled.div<{ size?: ModalWindowTypes }>`
  ${(props) => {
    const preset = sizeMap[props.size || 'fit'];
    return `
      height: ${preset.height || 'auto'};
      width: ${preset.width || 'auto'};
    `;
  }};
  padding: ${(props) => props.theme.spacing.spacing4};
  overflow-y: auto;
  position: relative;
  display: grid;
  grid-template-rows: min-content auto;
  gap: ${(props) => props.theme.spacing.spacing5};
`;

//@Deprecated("Use ModalWindow with SpruceTheme V2")
export const ModalWindowCardContent = styled.div<{ justifyContent?: JustifyContent; textAlign?: TextAlign }>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent || 'center'};
  text-align: ${(props) => props.textAlign || 'center'};
  height: 100%;
`;
